import React from 'react';
import { Routes as Router, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Vote from '../pages/Vote';

function Routes() {
    return (
        <Router>
            <Route path={'/'} element={<Home />}/>
            <Route path={'/vote'} element={<Vote />}/>
            <Route path={'/buybte'} element={<Home />}/>
        </Router>
    )
}

export default Routes;
